import { useTranslation } from 'react-i18next';
import Config from 'arbitrip-common/client/utils/Config';
import { ReactComponent as AiIcon } from '@/img/icons/ai.svg';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        marginTop: theme.spacing(3),
        padding: theme.spacing(1, 2),
        backgroundColor: '#FAFAFA',
        borderRadius: 8,
        fontWeight: 500,
        fontSize: 12,
    },
    meta: {
        position: 'absolute',
        top: -18,
        right: 0,
        fontSize: 12,
        color: 'orange',
    },
    toggle: {
        color: (theme.palette.blue && theme.palette.blue.main) || '#2D65A1',
        textDecoration: 'underline',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
    },
}));

const TranslationToggleNotice = ({ translatedExists, showOriginal, onToggle, durationMs, style }) => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    if (!translatedExists) return null;
    const dir = i18n.dir();
    const message = showOriginal
        ? t('TranslationToggleNotice.TextIsOriginal')
        : t('TranslationToggleNotice.TextIsTranslated');
    const buttonLabel = showOriginal
        ? t('TranslationToggleNotice.ViewTranslationCTA')
        : t('TranslationToggleNotice.ViewOriginalCTA');
    const showMeta = !!Config?.dev_mode && durationMs > 0;
    const seconds = showMeta ? (durationMs / 1000).toFixed(1) : null;
    return (
        <div className={classes.root} dir={dir} style={style}>
            {showMeta && <div className={classes.meta}>Translation took {seconds}s</div>}
            <span aria-hidden="true">
                <AiIcon />
            </span>
            <span>{message}</span>
            <button type="button" onClick={onToggle} className={classes.toggle}>
                {buttonLabel}
            </button>
        </div>
    );
};

export default TranslationToggleNotice;
